module.exports = __webpack_public_path__ + "img/toplayer.4ec15fd2.png";